"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.RecordCallSquare = exports.RecordCallCircle = exports.RecordCall = exports.PhoneRounded = exports.PhoneCallingRounded = exports.PhoneCalling = exports.Phone = exports.OutgoingCallRounded = exports.OutgoingCall = exports.IncomingCallRounded = exports.IncomingCall = exports.EndCallRounded = exports.EndCall = exports.CallMedicineRounded = exports.CallMedicine = exports.CallDroppedRounded = exports.CallDropped = exports.CallChatRounded = exports.CallChat = exports.CallCancelRounded = exports.CallCancel = void 0;
var CallCancel_1 = require("./CallCancel");
__createBinding(exports, CallCancel_1, "default", "CallCancel");
var CallCancelRounded_1 = require("./CallCancelRounded");
__createBinding(exports, CallCancelRounded_1, "default", "CallCancelRounded");
var CallChat_1 = require("./CallChat");
__createBinding(exports, CallChat_1, "default", "CallChat");
var CallChatRounded_1 = require("./CallChatRounded");
__createBinding(exports, CallChatRounded_1, "default", "CallChatRounded");
var CallDropped_1 = require("./CallDropped");
__createBinding(exports, CallDropped_1, "default", "CallDropped");
var CallDroppedRounded_1 = require("./CallDroppedRounded");
__createBinding(exports, CallDroppedRounded_1, "default", "CallDroppedRounded");
var CallMedicine_1 = require("./CallMedicine");
__createBinding(exports, CallMedicine_1, "default", "CallMedicine");
var CallMedicineRounded_1 = require("./CallMedicineRounded");
__createBinding(exports, CallMedicineRounded_1, "default", "CallMedicineRounded");
var EndCall_1 = require("./EndCall");
__createBinding(exports, EndCall_1, "default", "EndCall");
var EndCallRounded_1 = require("./EndCallRounded");
__createBinding(exports, EndCallRounded_1, "default", "EndCallRounded");
var IncomingCall_1 = require("./IncomingCall");
__createBinding(exports, IncomingCall_1, "default", "IncomingCall");
var IncomingCallRounded_1 = require("./IncomingCallRounded");
__createBinding(exports, IncomingCallRounded_1, "default", "IncomingCallRounded");
var OutgoingCall_1 = require("./OutgoingCall");
__createBinding(exports, OutgoingCall_1, "default", "OutgoingCall");
var OutgoingCallRounded_1 = require("./OutgoingCallRounded");
__createBinding(exports, OutgoingCallRounded_1, "default", "OutgoingCallRounded");
var Phone_1 = require("./Phone");
__createBinding(exports, Phone_1, "default", "Phone");
var PhoneCalling_1 = require("./PhoneCalling");
__createBinding(exports, PhoneCalling_1, "default", "PhoneCalling");
var PhoneCallingRounded_1 = require("./PhoneCallingRounded");
__createBinding(exports, PhoneCallingRounded_1, "default", "PhoneCallingRounded");
var PhoneRounded_1 = require("./PhoneRounded");
__createBinding(exports, PhoneRounded_1, "default", "PhoneRounded");
var RecordCall_1 = require("./RecordCall");
__createBinding(exports, RecordCall_1, "default", "RecordCall");
var RecordCallCircle_1 = require("./RecordCallCircle");
__createBinding(exports, RecordCallCircle_1, "default", "RecordCallCircle");
var RecordCallSquare_1 = require("./RecordCallSquare");
__createBinding(exports, RecordCallSquare_1, "default", "RecordCallSquare");
